const data = [
  {
    id: 1,
    question: "What do you need to start working on my project?",
    answer:
      "It mostly depends on the type of project. But in general, you need a fair idea of what you want, then we can take it from there."
  },
  {
    id: 2,
    question: "How long will my project take to complete?",
    answer:
      "This depends on the complexity of the project, your availability, and your payment. Once you have this sorted out, I will give you a completion date."
  },
  {
    id: 3,
    question: "Is hosting and domain registration inclusive in your pricing?",
    answer:
      "No. Hosting and domain are taken care of separately. You can pay for it or take care of it on your own if you know how to."
  },
  {
    id: 4,
    question: "How much do you charge for an average website or app?",
    answer:
      "Once again, this depends. But my prices are affordable, so you're good."
  }
];

export default data;
